/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { Grid, Paper, Alert, AlertTitle, Typography, Dialog, Button } from '@mui/material';
import { FieldErrors, FormProvider, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { PartnerService } from 'services';
import { useRegisterUserForm, useAuth } from 'hooks';
import {
	FormTextInput,
	SubmitButton
} from 'components';
import { RegisterUserFormProps } from './RegisterUserFormProps';
import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';

export const RegisterUserForm = ({ open, setOpen, placement, placementPartnerId }: RegisterUserFormProps) => {
	const { schema } = useRegisterUserForm();
	const queryClient = useQueryClient();
	const { currentUserId } = useAuth();
	type FormFields = z.infer<typeof schema>;
	const methods = useForm<FormFields>({
		resolver: zodResolver(schema),
		mode: 'onBlur',
		defaultValues: {
			placement: placement,
			placementPartnerId: placementPartnerId,
			mentorId: currentUserId
		}
	});
	const onSubmit = async (data: FormFields) => {
		try {
			await PartnerService.registerUser(data);
			queryClient.invalidateQueries({ queryKey: ['organization-chart-nodes'] });
			handleCloseDialog();
		} catch (e: any) {
			methods.setError('root', { type: 'manual', message: e.response?.data });
		}
	};
	const onError = async (data: FieldErrors<FormFields>) => {
		console.log(data);
	};
	const handleCloseDialog = () => {
		methods.reset();
		setOpen(false);
	};
	useEffect(() => {
		methods.setValue('placement', placement);
		methods.setValue('placementPartnerId', placementPartnerId);
	}, [placement, placementPartnerId]);
	return (
		<>
			{
				open && (
					<>
						<Dialog open={open} onClose={handleCloseDialog} fullWidth>
							<FormProvider {...methods}>
								<form onSubmit={methods.handleSubmit(onSubmit, onError)}>
									<Grid container justifyContent='center' textAlign={'center'} spacing={2} component={Paper} p={5}>
										{methods.formState?.errors?.root?.message && (
											<Grid item xs={12} textAlign={'start'}>
												<Alert severity='error' sx={{ maxWidth: '100%' }} >
													<AlertTitle>Error</AlertTitle>
													<Typography variant='subtitle2' gutterBottom>
														{methods.formState.errors.root?.message}
													</Typography>
												</Alert>
											</Grid>
										)}
										<Grid item xs={12}>
											<FormTextInput name='email' />
										</Grid>
										<Grid item xs={6}>
											<FormTextInput name='firstName' />
										</Grid>
										<Grid item xs={6}>
											<FormTextInput name='lastName' />
										</Grid>
										<Grid item xs={6}>
											<FormTextInput name='city' />
										</Grid>
										<Grid item xs={6}>
											<FormTextInput name='zipCode' />
										</Grid>
										<Grid item xs={6}>
											<FormTextInput name='country' />
										</Grid>
										<Grid item xs={6}>
											<FormTextInput name='phoneNumber' />
										</Grid>
										<Grid item xs={6}>
											<FormTextInput name='password' type='password' />
										</Grid>
										<Grid item xs={6}>
											<FormTextInput name='confirmPassword' type='password' />
										</Grid>
										<Grid item xs={6}>
											<SubmitButton text='Register' />
										</Grid>
										<Grid item xs={6}>
											<Button variant='contained' fullWidth onClick={handleCloseDialog}>Cancel</Button>
										</Grid>
									</Grid>
								</form>
							</FormProvider>
						</Dialog>
					</>
				)
			}
		</>
	);
};
